/*
 * Smores scroll-reveal — cascades grid items up as they enter the viewport.
 * Safe by design:
 *   - Only marks items that start BELOW the fold, so above-fold content is
 *     never hidden / never flashes.
 *   - A failsafe timeout reveals everything, so a missed observer can't
 *     leave content stuck hidden.
 *   - Fully skipped when the user prefers reduced motion.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    '.smores-card',
    '.smores-follow__card',
    '.smores-reviews__card',
    '.smores-social__card',
    '.smores-values__item',
    '.smores-timeline__item',
    '.smores-blog-list__card',
    '.smores-faq__step',
    '.smores-instructions__row',
    '[data-reveal]'
  ].join(',');

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    var targets = nodes.filter(function (el) {
      // only below-fold items (don't touch anything already visible)
      return el.getBoundingClientRect().top > vh * 0.85;
    });
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add('smores-reveal');
      // stagger items within the same parent for a cascade
      var idx = 0;
      if (el.parentElement) idx = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--reveal-delay', (Math.min(idx, 6) * 0.07) + 's');
    });

    var revealAll = function () { targets.forEach(function (el) { el.classList.add('is-in'); }); };

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });

    // Failsafe: never let anything stay hidden.
    setTimeout(revealAll, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
